import { Country, State } from "@prisma/client"
import React, { useState } from "react"
import { createContext, useContext } from "react"
import { Continent } from "../components/place-selector"

const AppContext = createContext<{
  countryList: Country[]
  setCountryList?: (countryList: Country[]) => void

  stateList: State[]
  setStateList?: (stateList: State[]) => void

  continentList: Continent[]
  setContinentList?: (continentList: Continent[]) => void
}>({
  countryList: [],
  stateList: [],
  continentList: [],
})

export const AppContextProvider: React.FC = ({ children }) => {
  const [countryList, setCountryList] = useState<Country[]>([])
  const [stateList, setStateList] = useState<State[]>([])
  const [continentList, setContinentList] = useState<Continent[]>([])

  return (
    <AppContext.Provider
      value={{
        countryList,
        setCountryList,

        stateList,
        setStateList,

        continentList,
        setContinentList,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export function useCountryList() {
  const { countryList, setCountryList } = useContext(AppContext)

  return { countryList, setCountryList }
}

export function useContinentList() {
  const { continentList, setContinentList } = useContext(AppContext)

  return { continentList, setContinentList }
}

export function useStateList() {
  const { stateList, setStateList } = useContext(AppContext)

  return { stateList, setStateList }
}
